<!-- 开通月卡接口简约内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "carNo": "粤TEST02",
                "carOwner": "张三",
                "company ": "123",
                "operateTime": "2017-11-07 00:00:00",
                "operator": "admin123",
                "parkCode": "2KM43Y461",
                "telephone": "18022222222",
                "timePeriod": {
                    "endTime": "2018-03-31 23:59:59",
                    "startTime": "2017-02-28 00:00:00"
                },
                "uniqNo": "20180108184002",
                "vipTypeName": "月卡TEST"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台开通月卡（简约版）,只适合vip基础功能，不适合多位多车功能",
                t_url: this.commonUrls.test + "addVipTicketSimple",
                p_url: this.commonUrls.prod + "addVipTicketSimple",
                precondition: "VEMS 2.13及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'vipTypeName', info2: '是', info3: 'String', info4: 'VIP类型名称' },
                        { info1: 'uniqNo', info2: '是', info3: 'String', info4: '唯一编号' },
                        { info1: 'carOwner', info2: '是', info3: 'String', info4: '车主' },
                        { info1: 'telephone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'company', info2: '否', info3: 'String', info4: '车主公司' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作员' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'timePeriod', info2: '是', info3: 'JSONObject', info4: '有效时间段' },
                    ]
                }, {
                    titleName: 'timePeriod',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，yyyy-MM-dd HH:mm:ss' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/vip/addVipTicketSimple.vue